const headerLinks = {
  nav: [
    {
      text: 'EV Solutions',
      nav: [
        {
          text: 'Case Studies',
          to: '/case-studies',
        },
        {
          text: 'Channel / Reseller Program',
          to: '/resellers',
        },
        {
          text: 'Drivers',
          to: '/drivers',
        },
      ],
    },
    {
      text: 'Technology',
      to: '/technology',
    },
    {
      text: 'Platform',
      to: '/platform',
    },
    {
      text: 'About Us',
      to: '/about-us',
    },
  ],
  cta: {
    login: {
      text: 'Login',
      nav: [
        {
          text: 'Building Manager Login',
          href: 'https://desktop.xealenergy.com/',
        },
        {
          text: 'Partner Login',
          href: 'https://xealenergy.my.site.com/PRM',
        },
      ],
      // href: 'https://xealenergy.com',
    },
    talk: {
      text: "Let's talk",
      modal: {
        title: 'Talk to a Specialist',
      },
    },
  },
  logins: {
    buildingManager: {
      text: 'Building Manager Login',
      href: 'https://desktop.xealenergy.com/',
    },
    partner: {
      text: 'Partner Login',
      href: 'https://xealenergy.my.site.com/PRM',
    },
  },
}

export const headerLinks2 = {
  nav: [
    {
      text: 'EV Solutions',
      nav: [
        {
          text: 'Case Studies',
          to: '/case-studies',
        },
        {
          text: 'Channel / Reseller Program',
          to: '/resellers',
        },
        {
          text: 'Drivers',
          to: '/drivers',
        },
      ],
    },
    {
      text: 'Technology',
      to: '/about-us',
    },
    {
      text: 'Platform',
      to: '/platform-ev',
    },
    {
      text: 'About Us',
      to: '/about-us',
    },
  ],
  cta: {
    login: {
      text: 'Login',
      href: 'https://xealenergy.com',
    },
    talk: {
      text: "Let's talk",
      modal: {
        title: 'Talk to a Specialist',
      },
    },
  },
  logins: {
    buildingManager: {
      text: 'Building Manager Login',
      href: 'https://desktop.xealenergy.com/',
    },
    partner: {
      text: 'Partner Login',
      href: 'https://xealenergy.my.site.com/PRM',
    },
  },
}

export default headerLinks
